import Flex from 'components/Flex';
import styled from 'styled-components';

export default styled(Flex)`
  flex-direction: column;
  padding-bottom: 46px;
`;
